(function () {
  const panel    = document.getElementById('qv-panel');
  const body     = document.getElementById('qv-body');
  const closeBtn = document.getElementById('qv-close');
  const backdrop = document.getElementById('qv-backdrop');
  if (!panel || !body) return;

  function openPanel() {
    backdrop.hidden = false;
    document.documentElement.classList.remove('qv-closing');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      document.documentElement.classList.add('qv-open');
      panel.setAttribute('aria-hidden', 'false');
    });
  }

  function closePanelAsync() {
    return new Promise((resolve) => {
      if (window.location.hash) {
        history.pushState(null, null, window.location.pathname + window.location.search);
      }

      document.documentElement.classList.add('qv-closing');
      document.documentElement.classList.remove('qv-open');
      panel.setAttribute('aria-hidden', 'true');

      const done = () => {
        backdrop.hidden = true;
        document.body.style.overflow = '';
        panel.removeEventListener('transitionend', done);
        document.documentElement.classList.remove('qv-closing');
        resolve();
      };

      panel.addEventListener('transitionend', done, { once: true });
      setTimeout(done, 450);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') closePanelAsync();
  });

  backdrop?.addEventListener('click', (e) => {
    if (e.target === backdrop) closePanelAsync();
  });

  document.addEventListener('click', (e) => {
    if (!document.documentElement.classList.contains('qv-open')) return;
    const panel = document.getElementById('qv-panel');
    if (!panel) return;
    if (panel.contains(e.target)) return;
    if (e.target.closest('.qv-overlay, [data-qv-handle], [data-gpo-collection-qvActivator]')) return;
    closePanelAsync();
  });

  closeBtn?.addEventListener('click', closePanelAsync);

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function getPreviewThemeId() {
    if (window.Shopify?.theme?.id) return String(Shopify.theme.id);
    const u = new URL(location.href);
    if (u.searchParams.get('preview_theme_id')) return u.searchParams.get('preview_theme_id');
    try {
      const m = /preview_theme_id=(\d+)/.exec(document.cookie + ' ' + document.documentElement.outerHTML);
      if (m) return m[1];
    } catch {}
    return null;
  }

  // ============================================================
  // Collection limit check
  // ============================================================
  async function qvCheckCollectionLimit(form, cart = null) {
    const collectionsInput = form.querySelector('[name="properties[_collections]"]');
    const collectionsStr = collectionsInput?.value || '';
    const collections = collectionsStr.split(',').map(c => c.trim()).filter(Boolean);

    if (!collections.length) return { allowed: true };

    const isColorSample = collections.some(c => c.includes('color-sample'));

    let limit = 4;
    let groupKey = null;

    if (isColorSample) {
      groupKey = collections.find(c => c.includes('color-sample'));
      limit = 4;
    } else if (collections.includes('semi-custom-tiles')) {
      groupKey = 'semi-custom-tiles';
      limit = 10;
    } else if (collections.includes('designer-tiles')) {
      groupKey = 'designer-tiles';
      limit = 4;
    } else {
      groupKey = collections[0];
      limit = 4;
    }

    if (!cart) cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());

    const colorSampleKey = `${groupKey}-color-sample`;
    const totalInCollection = cart.items.reduce((sum, item) => {
      const itemCollections = (item.properties?._collections || '').split(',').map(c => c.trim()).filter(Boolean);
      if (itemCollections.includes(colorSampleKey)) return sum;
      return itemCollections.includes(groupKey) ? sum + item.quantity : sum;
    }, 0);

    if (totalInCollection >= limit) {
      const language = document.documentElement.lang || 'en';
      const messages = {
        en: `The samples in this category are limited to ${limit} items. You already have ${totalInCollection} in your cart.`,
        ja: `このカテゴリーのサンプルは${limit}点まで選択できます。すでにカートに${totalInCollection}点入っています。`
      };
      return { allowed: false, message: messages[language] || messages.en };
    }

    return { allowed: true };
  }

  // ============================================================
  // Cart sections
  // ============================================================
  function collectCartSectionIds() {
    const ids = ['cart-icon-bubble', 'cart-notification-product', 'cart-notification-button'];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    return ids;
  }

  function getSectionInnerHTML(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  async function qvAjaxAddToCart(form) {
    const fd = new FormData(form);

    const sectionIds = collectCartSectionIds();
    if (sectionIds.length) {
      fd.append('sections', sectionIds.join(','));
      fd.append('sections_url', window.location.pathname);
    }

    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    });

    const json = await res.json();

    if (!res.ok) {
      const msg = json?.description || json?.message || 'カートに追加できませんでした。';
      throw new Error(msg);
    }

    if (json.sections) {
      renderCartSections(json.sections, json.key);
    }

    return json;
  }

  function renderCartSections(map, itemKey) {
    if (map['cart-icon-bubble']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = map['cart-icon-bubble'];

      const incomingBubble = tmp.querySelector('.cart-count-bubble');
      const cartIconLink   = document.querySelector('#cart-icon-bubble');

      if (cartIconLink && incomingBubble) {
        const existingBubble = cartIconLink.querySelector('.cart-count-bubble');

        if (existingBubble) {
          existingBubble.replaceWith(incomingBubble);
        } else {
          cartIconLink.prepend(incomingBubble);
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const bubble = cartIconLink.querySelector('.cart-count-bubble');
            if (bubble) {
              bubble.style.transition = 'background-color 0.3s ease';
              bubble.style.backgroundColor = '#FFE7E7';
              setTimeout(() => {
                bubble.style.backgroundColor = '';
              }, 300);
            }
          });
        });
      }
    }

    if (map['cart-notification-product']) {
      const container = document.getElementById('cart-notification-product');
      if (container) {
        const selector = itemKey ? `[id="cart-notification-product-${itemKey}"]` : '.shopify-section';
        container.innerHTML = getSectionInnerHTML(map['cart-notification-product'], selector);
      }
    }

    if (map['cart-notification-button']) {
      const button = document.getElementById('cart-notification-button');
      if (button) button.innerHTML = getSectionInnerHTML(map['cart-notification-button'], '.shopify-section');
    }

    if (map['cart-drawer']) {
      const drawer = document.getElementById('CartDrawer');
      if (drawer) drawer.innerHTML = getSectionInnerHTML(map['cart-drawer'], '#CartDrawer');
    }

    setTimeout(() => {
      const note    = document.querySelector('cart-notification');
      const notifEl = document.getElementById('cart-notification');
      if (notifEl) notifEl.style.display = '';
      if (note && typeof note.open === 'function') note.open();
    }, 50);
  }

  function openCartUI() {
    const drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.setAttribute('open', '');
      return true;
    }

    const note = document.querySelector('cart-notification');
    if (note) {
      if (typeof note.open === 'function') note.open();
      else note.setAttribute('open', '');
      return true;
    }

    return false;
  }

  // ============================================================
  // Toast
  // ============================================================
  let qvToastTimer;
  function qvToast(text) {
    clearTimeout(qvToastTimer);
    let el = document.getElementById('qv-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'qv-toast';
      el.style.cssText = 'position:fixed;right:16px;bottom:16px;z-index:9999;padding:10px 14px;background:#111;color:#fff;border-radius:8px;font-size:14px;opacity:0;transform:translateY(8px);transition:.2s';
      document.body.appendChild(el);
    }
    el.textContent = text;
    requestAnimationFrame(() => { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; });
    qvToastTimer = setTimeout(() => { el.style.opacity = '0'; el.style.transform = 'translateY(8px)'; }, 1600);
  }

  // ============================================================
  // Quick view trigger (click)
  // ============================================================
  document.addEventListener('click', async (e) => {
    const t = e.target.closest('.qv-overlay, [data-qv-handle], [data-gpo-collection-qvActivator]');
    if (!t) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    const handle = t.getAttribute('data-qv-handle');
    if (!handle) return;

    history.pushState(null, null, `#${handle}`);

    body.innerHTML = '<div style="opacity:.7">Loading…</div>';
    openPanel();

    try {
      await loadQuickViewInto(body, handle);
    } catch (err) {
      console.error('[QV] Unhandled error', err);
      body.innerHTML = '<div style="color:#b00">Failed to load product.</div>';
    }
  }, true);

  // ============================================================
  // Load product HTML into quick view
  // ============================================================
  async function loadQuickViewInto(target, handle) {
    const themeId  = getPreviewThemeId();
    const previewQ = themeId ? `&preview_theme_id=${encodeURIComponent(themeId)}` : '';
    const view     = 'quick-view';
    const section  = 'product-quick-view';

    const directUrl = `${root}products/${encodeURIComponent(handle)}?view=${encodeURIComponent(view)}&section_id=${encodeURIComponent(section)}${previewQ}`;
    console.debug('[QV] direct section GET', directUrl);
    let res = await fetch(directUrl, { credentials: 'same-origin' });
    let html = await res.text();
    if (res.ok && html && html.trim()) {
      target.innerHTML = html;
      afterInject(target);
      return;
    }
    console.warn('[QV] direct section failed or empty, status:', res.status);

    const sectionIdKey = 'main';
    const sectionsUrl  = `${root}products/${encodeURIComponent(handle)}?view=${encodeURIComponent(view)}${previewQ}`;
    const apiUrl       = `${root}?sections=${encodeURIComponent(sectionIdKey)}&sections_url=${encodeURIComponent(sectionsUrl)}`;
    console.debug('[QV] sections API', apiUrl);
    res = await fetch(apiUrl, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    if (res.ok) {
      try {
        const payload = await res.json();
        html = payload && payload[sectionIdKey];
        if (html && html.trim()) {
          target.innerHTML = html;
          afterInject(target);
          return;
        }
        console.warn('[QV] sections payload empty', payload);
      } catch (e) {
        console.error('[QV] sections JSON parse error', e);
      }
    } else {
      console.error('[QV] sections API HTTP', res.status, await res.text());
    }

    console.debug('[QV] fallback page GET', sectionsUrl);
    res = await fetch(sectionsUrl, { credentials: 'same-origin' });
    html = await res.text();
    if (!res.ok) {
      console.error('[QV] fallback page failed', res.status, html.slice(0, 500));
      throw new Error('Fallback page failed');
    }
    let m = html.match(/<(section)\b[^>]*id="shopify-section-[^"]+"[\s\S]*?<\/section>/i);
    if (!m) m = html.match(/<(div)\b[^>]*id="shopify-section-[^"]+"[\s\S]*?<\/div>/i);
    if (m && m[0]) {
      target.innerHTML = m[0];
      afterInject(target);
      return;
    }

    console.error('[QV] could not find section markup in fallback. First 300 chars:', html.slice(0, 300));
    target.innerHTML = '<div style="color:#b00">Failed to load product.</div>';
    throw new Error('No section markup');
  }

  // ============================================================
  // Init quick view form + variant tiles
  // ============================================================
  function setAtcButtonState(atcBtn, soldOut) {
    if (!atcBtn) return;
    atcBtn.disabled = soldOut;
    atcBtn.textContent = soldOut
      ? (atcBtn.dataset.textSoldout || 'Sold Out')
      : (atcBtn.dataset.textAtc || 'Add to cart');
  }

  function initQuickView(root) {
    const qvRoot = root.querySelector('[data-qv-root]');
    if (!qvRoot) return;

    const form    = qvRoot.querySelector('[data-qv-form]');
    const tiles   = qvRoot.querySelectorAll('[data-qv-tiles] .qv__variant-tile');
    const idInput = qvRoot.querySelector('[data-qv-variant-id]');
    const atcBtn  = qvRoot.querySelector('[data-qv-atc]');
    const mainImage = qvRoot.querySelector('.qv__main-image');

    if (!form) return;

    if (tiles.length && idInput) {
      function selectTile(tile, skipAltUpdate = false) {
        if (tile.classList.contains('is-soldout')) return;

        tiles.forEach(t => {
          t.classList.remove('is-selected');
          t.setAttribute('aria-pressed', 'false');
        });
        tile.classList.add('is-selected');
        tile.setAttribute('aria-pressed', 'true');

        const vid       = tile.getAttribute('data-variant-id');
        const available = tile.getAttribute('data-available') === 'true';

        if (vid) {
          idInput.value = vid;
          const select = form.querySelector('[data-qv-variant-select]');
          if (select) select.value = vid;
        }

        setAtcButtonState(atcBtn, !available);

        const variantNameEl = qvRoot.querySelector('[id^="qv-variant-name-"]');
        if (variantNameEl) {
          const label = tile.querySelector('.qv__variant-label');
          variantNameEl.textContent = label ? label.textContent.trim() : '';
        }

        const imgUrl = tile.getAttribute('data-image');
        if (mainImage && imgUrl) {
          mainImage.src = imgUrl;
          mainImage.removeAttribute('srcset');
          const altValue = tile.getAttribute('data-image-alt') || '';
          mainImage.alt = altValue;

          if (!skipAltUpdate) {
            const altText = document.querySelector('#qv-image-alt');
            if (altText) {
              altText.textContent = altValue;
              altText.style.display = altValue ? 'block' : 'none';
            }
          }

          const thumbnails = qvRoot.querySelectorAll('.qv__thumbnail');
          thumbnails.forEach(thumb => thumb.classList.remove('is-active'));

          let matchedThumb = Array.from(thumbnails).find(thumb => thumb.getAttribute('data-media-url') === imgUrl);
          if (!matchedThumb && thumbnails.length > 0) matchedThumb = thumbnails[0];

          if (matchedThumb) {
            matchedThumb.classList.add('is-active');
            const thumbIndex = Array.from(thumbnails).indexOf(matchedThumb);
            if (thumbIndex >= 0) {
              const pageIndex = Math.floor(thumbIndex / 5) * 5;
              const gallery   = qvRoot.querySelector('.qv__thumbnail-gallery');
              const track     = qvRoot.querySelector('.qv__thumbnail-track');
              if (gallery && track) {
                const gap        = 8;
                const thumbWidth = (track.offsetWidth - gap * 4) / 5;
                gallery.style.transform = 'translateX(-' + (pageIndex * (thumbWidth + gap)) + 'px)';
              }
            }
          }
        }
      }

      tiles.forEach(tile => tile.addEventListener('click', () => selectTile(tile)));

      const firstAvailable = qvRoot.querySelector('.qv__variant-tile:not(.is-soldout)');
      if (firstAvailable) {
        selectTile(firstAvailable, true);
      } else if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = atcBtn.dataset.textSoldout || 'Sold Out';
      }
    } else if (atcBtn) {
      // Single-variant: check availability from the hidden select
      const select = form.querySelector('[data-qv-variant-select]');
      const selectedOption = select && select.querySelector('option:not([disabled])');
      if (!selectedOption) {
        atcBtn.disabled = true;
        atcBtn.textContent = atcBtn.dataset.textSoldout || 'Sold Out';
      }
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (tiles.length && idInput) {
        const current = qvRoot.querySelector('.qv__variant-tile.is-selected');
        if (current) {
          const vid = current.getAttribute('data-variant-id');
          idInput.value = vid;
          const select = form.querySelector('[data-qv-variant-select]');
          if (select) select.value = vid;
        }
      }

      if (atcBtn) atcBtn.disabled = true;

      try {
        const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());

        const cartLimitCheck = await qvCheckCollectionLimit(form, cart);
        if (!cartLimitCheck.allowed) {
          qvToast(cartLimitCheck.message);
          if (atcBtn) atcBtn.disabled = false;
          return;
        }

        const vid = idInput && idInput.value;
        const tile = tiles.length ? qvRoot.querySelector(`.qv__variant-tile[data-variant-id="${vid}"]`) : null;
        const invSrc = tile || idInput;
        if (invSrc && invSrc.dataset.invManaged === 'shopify' && invSrc.dataset.invPolicy !== 'continue') {
          const invQty = parseInt(invSrc.dataset.invQty) || 0;
          const cartQty = cart.items
            .filter(i => String(i.variant_id) === String(vid))
            .reduce((s, i) => s + i.quantity, 0);
          if (cartQty >= invQty) {
            const language = document.documentElement.lang || 'en';
            qvToast(language === 'ja' ? `在庫は${invQty}個までです。` : `Only ${invQty} item(s) available in stock.`);
            if (atcBtn) atcBtn.disabled = false;
            return;
          }
        }

        await qvAjaxAddToCart(form);

        if (atcBtn) atcBtn.disabled = false;

        if (!openCartUI()) qvToast('カートに追加しました');

        closePanelAsync().then(() => {
          const visibleCircle = document.querySelector('#cart-icon-bubble .cart-count-bubblee');
          if (visibleCircle) {
            visibleCircle.style.transition = 'background-color 0.3s ease';
            visibleCircle.style.backgroundColor = '#FFE7E7';
            setTimeout(() => {
              visibleCircle.style.backgroundColor = '';
            }, 300);
          }
        });

      } catch (err) {
        console.error('[QV] Add to cart failed', err);
        qvToast(err.message || 'カートに追加できませんでした');
        if (atcBtn) atcBtn.disabled = false;
      }
    });
  }

  // ============================================================
  // Thumbnail slider
  // ============================================================
  function initQvThumbnailSlider(scope) {
    const qvRoot  = scope.querySelector('[data-qv-root]') || scope;
    const slider  = qvRoot.querySelector('.qv__thumbnail-slider');
    if (!slider) return;

    const track     = slider.querySelector('.qv__thumbnail-track');
    const gallery   = slider.querySelector('.qv__thumbnail-gallery');
    const thumbs    = Array.from(gallery.querySelectorAll('.qv__thumbnail'));
    const prevBtn   = qvRoot.querySelector('.qv__thumb-prev');
    const nextBtn   = qvRoot.querySelector('.qv__thumb-next');
    const mainImage = qvRoot.querySelector('.qv__main-image');

    const perPage = 5;
    let current   = 0;
    const total   = thumbs.length;

    if (total <= perPage) {
      if (prevBtn) prevBtn.classList.add('is-hidden');
      if (nextBtn) nextBtn.classList.add('is-hidden');
    }

    function getThumbWidth() {
      return (track.offsetWidth - 8 * (perPage - 1)) / perPage;
    }

    function setThumbWidths() {
      const w = getThumbWidth();
      thumbs.forEach(t => { t.style.width = w + 'px'; });
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= total - perPage;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, total - perPage));
      gallery.style.transform = 'translateX(-' + (current * (getThumbWidth() + 8)) + 'px)';
      updateNav();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const url = thumb.getAttribute('data-media-url');
        const alt = thumb.getAttribute('data-media-alt') || '';
        if (mainImage && url) {
          mainImage.src = url;
          mainImage.removeAttribute('srcset');
          mainImage.alt = alt;
        }
      });
    });

    setThumbWidths();
    updateNav();
    window.addEventListener('resize', () => { setThumbWidths(); goTo(current); });
  }

  // ============================================================
  // After HTML inject
  // ============================================================
  function afterInject(scope) {
    const secEl = scope.querySelector('[id^="shopify-section-"]');
    if (secEl) {
      secEl.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      const secKey = secEl.id.replace('shopify-section-', '');
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: secKey } }));
    }
    try { if (window.GPO && typeof window.GPO.init === 'function') window.GPO.init(); } catch {}

    initQuickView(scope);
    initQvThumbnailSlider(scope);
  }

  window.loadQuickViewInto = loadQuickViewInto;

})();

// ============================================================
// Auto-open quick view from URL hash
// ============================================================
(function () {
  async function openQuickViewFromHash() {
    const hash = window.location.hash;
    if (!hash || hash.length <= 1) return;
    const productHandle = hash.substring(1);
    if (!productHandle || productHandle.includes('=')) return;

    const panel = document.getElementById('qv-panel');
    const body  = document.getElementById('qv-body');
    if (!panel || !body) return;

    const savedTab = sessionStorage.getItem('collection-active-tab');
    if (savedTab && typeof switchTab === 'function') switchTab(savedTab);

    body.innerHTML = '<div style="opacity:.7">Loading…</div>';

    const openPanel = () => {
      const backdrop = document.getElementById('qv-backdrop');
      if (backdrop) backdrop.hidden = false;
      document.documentElement.classList.remove('qv-closing');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        document.documentElement.classList.add('qv-open');
        panel.setAttribute('aria-hidden', 'false');
      });
    };

    openPanel();

    try {
      await loadQuickViewInto(body, productHandle);
    } catch (err) {
      console.error('[QV] Hash open failed', err);
      body.innerHTML = '<div style="color:#b00">Failed to load product.</div>';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openQuickViewFromHash);
  } else {
    openQuickViewFromHash();
  }

  window.addEventListener('hashchange', openQuickViewFromHash);
})();